import { render, staticRenderFns } from "./NormSeting.vue?vue&type=template&id=791c9ed4&scoped=true"
import script from "./NormSeting.vue?vue&type=script&lang=js"
export * from "./NormSeting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791c9ed4",
  null
  
)

export default component.exports